module.exports = __webpack_public_path__ + "img/searchnotfound.14c3ceb2.svg";